import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('@/views/Home.vue')
    },
    {
      path: '/create',
      name: 'create',
      component: () => import('@/views/create.vue')
    },
    {
      path: '/list',
      name: 'list',
      component: () => import('@/views/list.vue')
    },
    {
      path: '/r/:id',
      name: 'r',
      component: () => import('@/views/r.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '/file/:d',
      name: 'file',
      component: () => import('@/views/file.vue')
    },
    {
      path: '/subscribe',
      name: 'subscribe',
      component: () => import('@/views/subscribe.vue')
    },
    {
      path: '/autologin',
      name: 'autologin',
      component: () => import('@/views/autologin.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '/landing',
      name: 'landing',
      component: () => import('@/views/landing.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/Login.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '/activate',
      name: 'activate',
      component: () => import('@/views/activate.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '/error-404',
      name: 'error-404',
      component: () => import('@/views/error/Error404.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '*',
      name: 'error-4042',
      component: () => import('@/views/error/Error404.vue'),
      meta: {
        layout: 'full',
      },
    },
  ],
})

// ? For splash screen
// Remove afterEach hook if you are not using splash screen
router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})

export default router
